module.exports = __webpack_public_path__ + "media/images/front/event/dummypic3-3ddb72c4f560dee3fe868f25207f4e7c.svg";